import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Holiday  {
    _originalTypeClassName = "zERP.BO.Holiday";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Holiday.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Date = null;
this.Name = null;
this.NameGR = null;
this.IsWorkingDay = false;
this.Type = null;
this.Year = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
Name:any;
NameGR:any;
IsWorkingDay:any;
Type:any;
Year:any;
Entity:any;
EmploymentContractTemplate:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeHolidays(oldValue, $this);
}
Domain.BusinessEntity.addHolidays(value, $this);
}
}
static setEmploymentContractTemplate = ($this, value) => {
var oldValue = $this.EmploymentContractTemplate;
$this.EmploymentContractTemplate = value;
if (value != null) {
}
}

static GetNameGR($this: any): any{if ($this?.Name == "New Year's Day") {return "Πρωτοχρονιά";}
if ($this?.Name == "Epiphany") {return "Θεοφάνεια";}
if ($this?.Name == "Clean Monday") {return "Καθαρά Δευτέρα";}
if ($this?.Name == "Annunciation of the Virgin Mary") {return "Ευαγγελισμός της Θεοτόκου";}
if ($this?.Name == "Orthodox Good Friday") {return "Μεγάλη Παρασκευή";}
if ($this?.Name == "Orthodox Easter Monday") {return "Δευτέρα του Πάσχα";}
if ($this?.Name == "Labor Day / May Day") {return "Εργατική Πρωτομαγιά";}
if ($this?.Name == "Orthodox Holy Spirit Monday") {return "Αγίου Πνεύματος";}
if ($this?.Name == "Dormition of the Holy Virgin") {return "Κοίμηση της Θεοτόκου";}
if ($this?.Name == "The Ochi day") {return "Ημέρα του Όχι";}
if ($this?.Name == "Christmas Day") {return "Χριστούγεννα";}
if ($this?.Name == "Synaxis of the Mother of God") {return "Σύναξη της Υπεραγίας Θεοτόκου";}
if ($this?.Name == "Greek Independence Day") {return "Ελληνική Επανάσταση του 1821";}
if ($this?.Name == "Orthodox Easter Sunday") {return "Κυριακή του Πάσχα";}
if ($this?.Name == "Orthodox Holy Saturday") {return "Μεγάλο Σάββατο";}
return $this?.Name;
}
static GetNameGR1($this: any): any{return $this?.NameGR;
}
static GetYear($this: any): any{return moment($this?.Date).year();
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}